// src/domains/auth/hooks/useTokenValidation.ts

import i18n from '@/shared/i18n/i18n';
import { jwtDecode } from 'jwt-decode';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

type JwtPayload = {
  exp: number;
  sub: number;
};

export function useTokenValidation() {
  const location = useLocation();
  const [token, setToken] = useState<string | null>(null);
  const [isValid, setIsValid] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const tokenParam = searchParams.get('token');

    if (!tokenParam) {
      setError(i18n.t('resetPassword.errors.tokenMissing'));
      return;
    }
    setToken(tokenParam);

    try {
      const decoded = jwtDecode<JwtPayload>(tokenParam);
      const currentTime = Date.now() / 1000;
      if (decoded.exp < currentTime) {
        setError(i18n.t('resetPassword.errors.tokenExpired'));
        setIsValid(false);
        return;
      } else {
        setIsValid(true);
      }
    } catch (err) {
      setError(i18n.t('resetPassword.errors.tokenInvalid'));
      setIsValid(false);
    }
  }, [location.search]);

  return { token, isValid, error };
}
